import { render, staticRenderFns } from "./GroupedBarChartNew.vue?vue&type=template&id=28ddd2a8&"
import script from "./GroupedBarChartNew.vue?vue&type=script&lang=js&"
export * from "./GroupedBarChartNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports